/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";


  const getIncidentList = async (page :number, size :number, sort :string, order : string, status: string, reasonId: any, keyword: any, deviationStatus: any) => {
    try {
      const headers = {
        'x-auth-token': authToken,
        'x-userid': authUserID,
      };
      const response = await axiosInstance.get(`${baseUrl}/deviations/list?page=${page}&size=${size}&sort=${sort}&order=${order}&location_type=${status}&reason_id=${reasonId}&keyword=${keyword}&status=${deviationStatus}`, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };

  const getReasonList = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/deviation/list_reason?status=active,inactive`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const changeDeviationStatus = async (dataToSend : any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/deviations/change_status`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getAreaId = async (Id:string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/location/get_details_by_id?id=${Id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

    
  const SaveDeviation = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/deviations/add_deviation`, dataToSend ,{
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };

  const getAreaByLocationCode = async (Id:string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/location/get_details_by_id?location_code=${Id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }
  const IncidentOrDeviationApi = {
    getIncidentList,
    getReasonList,
    changeDeviationStatus,
    getAreaId,
    SaveDeviation,
    getAreaByLocationCode
  }

  export { IncidentOrDeviationApi };
